import { mapActions } from 'vuex';

/**
 * A Vue mixin that manages the firstTimeCustomer flag.
 * Sets the color of the page background based on whether the customer is a first time customer or not.
 *
 * Provides the following data:
 * - isFirstTimeCustomer: boolean
 *
 * Provides the following methods:
 * - setSuccessBackground(): void - sets the background color to green
 * - resetBackground(): void - resets the background color to white
 *
 * When using this mixin, always call the `resetBackground` method in the `beforeDestroy` hook
 * (not to keep the color on the next page).
 *
 * @mixin
 */
export const firstTimeCustomerMixin = {
  data() {
    return {
      isFirstTimeCustomer: false,
    };
  },
  methods: {
    ...mapActions({
      setSuccessBackground: 'page/setSuccessBackground',
      resetBackground: 'page/resetBackground',
    }),
  },
  watch: {
    isFirstTimeCustomer(newValue) {
      if (newValue) {
        this.setSuccessBackground();
      } else {
        this.resetBackground();
      }
    },
  },
};
